"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bridge = _interopRequireDefault(require("./bridge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Authentication = /*#__PURE__*/function () {
  function Authentication() {
    _classCallCheck(this, Authentication);

    this.com = null;
    this.userData = null;
    this.access_token = null;
    this.userScopes = null;
  }

  _createClass(Authentication, [{
    key: "setComponent",
    value: function setComponent(com) {
      this.com = com;
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.com;
    }
  }, {
    key: "logout",
    value: function logout() {
      this.getComponent().logout();
    }
  }, {
    key: "setUserData",
    value: function setUserData(data) {
      this.userData = data;
    }
  }, {
    key: "getUserData",
    value: function getUserData() {
      return this.userData;
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(token) {
      this.access_token = token;
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return this.access_token;
    }
  }, {
    key: "setUserScopes",
    value: function setUserScopes(data) {
      this.userScopes = data.map(function (i) {
        return i.toLowerCase();
      });
    }
  }, {
    key: "getUserScopes",
    value: function getUserScopes() {
      return this.userScopes;
    }
    /**
     * Checks if the current logged in user has the required scope permission
     * @param scope
     * @param context
     * @returns {boolean}
     */

  }, {
    key: "can",
    value: function can(scope) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      scope = scope.toLowerCase();

      if (this.userScopes === null || !Array.isArray(this.userScopes)) {
        return false;
      }

      var hasScope = this.userScopes.indexOf(scope) !== -1;

      var contextHandlers = _bridge.default.getContextHandlers();

      if (hasScope && contextHandlers[scope]) {
        var func = contextHandlers[scope];

        if (typeof func === "function") {
          return func(this.getUserData(), context);
        }
      }

      return hasScope;
    }
    /**
     * Checks if the current logged in user does not have the required scope permission
     * @param scope
     * @param context
     * @returns {boolean}
     */

  }, {
    key: "canNot",
    value: function canNot(scope) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return !this.can(scope, context);
    }
    /**
     * @deprecated Please start using the .can || .canNot
     * @param scope
     * @returns {boolean}
     */

  }, {
    key: "hasScope",
    value: function hasScope(scope) {
      return this.can(scope);
    }
  }]);

  return Authentication;
}();

var _default = new Authentication();

exports.default = _default;